import React, { useState } from 'react';
// Remove PrescriptionKPI import since it's now inside DoctorList
import DoctorList from "../../../components/DoctorManagement/Doctor/View/List";

// import header, module menu ------------------------
import TopHeader from "../../../components/common/Header/TopHeader";
import DoctorManagementMenu from "../../../components/common/Menu/DoctorManagement";

export default function DoctorsPage() {
    const [currentPage, setCurrentPage] = useState(1);
    const itemsPerPage = 5;

    return (
        <main id="app">
            <TopHeader />
            <div className="content_wrapper">

                <section class="doctor-management-wrapper bg-white pb-5">
                    
                    {/* Inner Menu */}
                    <DoctorManagementMenu activeMenu='doctors'/>

                    <DoctorList currentPage={currentPage} itemsPerPage={itemsPerPage} />
                </section>
            </div>
        </main>
    );
}